import { DateTime } from "luxon";

/* 
	e.g. only yesterday: { startDayFromToday: -1, endDayFromToday: -1}
	today: { startDayFromToday: 0 }
	last week up until the end of today: { startDayFromToday: -7 }
*/
export function getTimeSpan(
	startDayFromToday: number,
	endDayFromToday: number | null
) {
	const now = DateTime.now();

	return {
		from: now.plus({ days: startDayFromToday }).startOf("day").toUTC(),
		to:
			endDayFromToday === null
				? now.endOf("day").toUTC()
				: now.plus({ days: endDayFromToday }).endOf("day").toUTC(),
	};
}
